import { render, staticRenderFns } from "./practice_plan_block_template_form.vue?vue&type=template&id=6de50711&"
import script from "./practice_plan_block_template_form.vue?vue&type=script&lang=js&"
export * from "./practice_plan_block_template_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports